/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import PageTitle from "../../components/pageTitle/PageTitle";
import { Button, Container, Tooltip } from "@material-ui/core";
import { getCompanyUsers } from "../../services/apiservices/employee";
import SingleSelect from "../../components/SelectField/SingleSelect";
import { DeleteAppointment, getAppoinmentByDates, subscribeToAppointmentsByDates } from "../../services/apiservices/appoinments";
import { getCompanyClients } from "../../services/apiservices/client";
import { useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";
import { makeStyles } from '@material-ui/core/styles';
import AuthContext from "../../hooks/authContext";
import { CommonSuccessDialog, DeleteApptDialog } from "../../components/DialogComponent/SupplyDataDialog";
import { AppointmentModal, AppointmentsDetailComponent } from "./Models/AppointmentModel";
import MonthView from "./Calendar/MonthViews";
import WeekView from "./Calendar/WeekViews";
import NavBar from "./Calendar/NavBar/Navigations";
import DayView from "./Calendar/DayViews";
import NorthWestIcon from '@mui/icons-material/NorthWest';
import commonContext from "../../hooks/commonContext";
import SingleSelectem from "../../components/SelectField/SingleSelectem";
import { getSettings, subscribeToSettings } from "../../services/apiservices/settings";
import moment from "moment";
import { useToast } from "../../hooks/useToast";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import { trackEvent, CMS_EVENTS } from "../../services/apiservices/analytics";

const useStyles = makeStyles({
  customTooltip: {
    fontSize: '12px',
    padding: '5px',
    top: "-20px",
    width: "80px",
    left: "20px",
  },
});

const ManageAppointments = () => {
  const [empNames, setEmpNames] = useState("All");
  const [employeeNameList, setEmployeeNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const [clientNameList, setClientNameList] = useState([]);
  const [clientDetails, setClientDetails] = useState();
  const [clientName, setClientName] = useState("All");
  const [employeeDetails, setEmployeeDetails] = useState();
  const [inactiveEmployee, setInactiveEmployee] = useState();
  const [allEmployees, setAllEmployees] = useState();
  const [appoinments, setAppoinments] = useState([]);
  let navigate = useNavigate();
  const [upcomingAppointments, setUpcomingAppointments] = useState({});
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [filteredAppointment, setFilteredAppointments] = useState([]);
  const [cancelAppt, setCancelAppt] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const auth = useContext(AuthContext);
  const [view, setView] = React.useState('month');
  const [alerts, setAlerts] = React.useState('todayAlerts');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [weekDates, setWeekDates] = useState([]);
  const [selectedDayDate, setSelectedDayDate] = useState();
  const [settingsData, setSettingsData] = useState();
  const editAppointmentData = auth?.editAppointmentData?.selectedAppointment;
  const appointmentRefs = useRef({});
  const isModalOpen = auth.isModalOpen;
  const setIsModalOpen = auth.setIsModalOpen;
  const selectedAppointment = auth.selectedAppointment;
  const setSelectedAppointment = auth.setSelectedAppointment;
  const classes = useStyles();
  const CommonContext = useContext(commonContext)
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { toast } = useToast();
  const updateAppointmentData = auth.updateAppointmentData?.matchingAppointments;

  const calculateDateRange = (view, currentDate, weekDates, selectedDayDate) => {
    let startDate, endDate;
    const newYorkDate = new Date(currentDate);

    if (view === "month") {
      const firstDayOfMonth = new Date(newYorkDate.getFullYear(), newYorkDate.getMonth(), 1);
      const lastDayOfMonth = new Date(newYorkDate.getFullYear(), newYorkDate.getMonth() + 1, 0);

      startDate = new Date(firstDayOfMonth);
      startDate.setDate(startDate.getDate() - 7);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(lastDayOfMonth);
      endDate.setDate(endDate.getDate() + 7);
      endDate.setHours(23, 59, 0, 0);
    }
    else if (view === "week") {
      if (Array.isArray(weekDates) && weekDates.length > 0) {
        startDate = new Date(weekDates[0]);
        startDate.setHours(0, 0, 0, 0);

        endDate = new Date(weekDates[weekDates.length - 1]);
        endDate.setHours(23, 59, 0, 0);
      } else {
        startDate = moment(currentDate).startOf('week').toDate();
        endDate = moment(currentDate).endOf('week').toDate();
      }
    }
    else if (view === "day") {
      const day = selectedDayDate || currentDate;
      startDate = new Date(day);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(day);
      endDate.setHours(23, 59, 0, 0);
    }

    return {
      startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
      endDate: moment(endDate).format("YYYY-MM-DDTHH:mm:ss")
    };
  };


  const ManageAppointmentsData = useCallback(async () => {
    // CommonContext?.setLoader(true);

    try {
      const [clientsResponse, employeesResponse] = await Promise.all([
        new Promise((resolve) => getCompanyClients(companyId, (res) => resolve(res?.data || []))),
        new Promise((resolve) => getCompanyUsers(companyId, (res) => resolve(res?.data || []))),
      ]);

      const clientRes = auth?.userProfile?.role === "Client" ? clientsResponse?.filter(item => item?.id === clientId) : clientsResponse;
      const employeeRes = employeesResponse;

      setClientDetails(clientRes);
      setAllEmployees(employeeRes);

      if (clientRes?.length > 0) {
        const sortedClients = clientRes
          ?.map(client => ({
            value: client?.id,
            label: client?.clientName,
            firstName: client?.firstName,
            lastName: client?.lastName,
          }))
          ?.sort((a, b) => a?.label?.localeCompare(b?.label));

        setClientNameList([
          { label: "All", value: "All" },
          ...sortedClients
        ]);
      } else {
        setClientDetails([]);
        setClientNameList([]);
      }

      if (employeeRes?.length > 0) {
        const activeEmployees = employeeRes?.filter(emp => ((Array.isArray(emp?.role) && emp?.role.includes("Employee")) || emp?.role === "Employee") && emp.companyId === companyId && emp.status !== false && !emp.deleted);
        setEmployeeDetails(activeEmployees);
        setInactiveEmployee(employeeRes?.filter(emp => ((Array.isArray(emp?.role) && emp?.role.includes("Employee")) || emp?.role === "Employee") && emp.companyId === companyId && (emp.status === false || emp.deleted)));

        const sortedEmployees = activeEmployees
          ?.map(emp => ({
            value: emp?.id,
            client: emp?.clients,
            label: `${emp?.firstName} ${emp?.lastName}`,
            email: emp?.email,
          }))
          ?.sort((a, b) => a?.label?.localeCompare(b?.label));

        setEmployeeNameList([
          { label: "All", value: "All" },
          ...sortedEmployees,
          { label: "Inactive Employee", value: "Inactive Employee" }
        ]);
      } else {
        setAllEmployees([]);
        setEmployeeDetails([]);
        setEmployeeNameList([]);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setClientDetails([]);
      setClientNameList([]);
      setAllEmployees([]);
      setEmployeeDetails([]);
      setEmployeeNameList([]);
    } finally {
      // CommonContext?.setLoader(false);
    }
  }, []);

  const fetchAppointments = async (appointmentResponse) => {
    try {
      if (appointmentResponse) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const filteredAppointments = appointmentResponse?.filter((item) => !item?.canceled && (auth?.userProfile?.role !== "Client" || item?.clientId === clientId));
        const filterAppointments = filteredAppointments.filter((appointment) => {
          const appointmentDateTime = new Date(appointment.appointmentDateTime);
          const appointmentDate = new Date(
            appointmentDateTime.getFullYear(),
            appointmentDateTime.getMonth(),
            appointmentDateTime.getDate()
          );

          const isPastOrToday = appointmentDate <= today;
          const user = allEmployees?.find((item) => ((Array.isArray(item?.role) && item?.role.includes("Employee")) || item?.role === "Employee") && item.userId === appointment.userId);

          if (user && (user.status === false || user.deleted)) {
            return isPastOrToday;
          }
          return true;
        });

        setAppoinments(filterAppointments);
        auth?.setAppointmentsData(filterAppointments);

        const upcomingAppointments = filterAppointments.sort((a, b) => {
          const dateA = a?.apoointmentDetails?.date || "";
          const dateB = b?.apoointmentDetails?.date || "";
          const timeA = a?.apoointmentDetails?.time || "";
          const timeB = b?.apoointmentDetails?.time || "";

          const dateCompare = dateA.localeCompare(dateB);
          return dateCompare !== 0
            ? dateCompare
            : timeA.localeCompare(timeB);
        });

        const groupedByDate = upcomingAppointments.reduce((grouped, appointment) => {
          const date = appointment?.apoointmentDetails?.date;
          if (!date) return grouped;
          if (!grouped[date]) grouped[date] = [];
          grouped[date].push(appointment);
          return grouped;
        }, {});
        setUpcomingAppointments(groupedByDate);
        if (view === "month") {
          const currentMonth = currentDate.getMonth();
          const currentYear = currentDate.getFullYear();

          const filteredByMonth = Object.entries(groupedByDate).reduce((result, [date, appointments]) => {
            const dateObj = new Date(date);
            if (dateObj.getMonth() === currentMonth && dateObj.getFullYear() === currentYear) {
              result[date] = appointments;
            }
            return result;
          }, {});
          setFilteredAppointments(filteredByMonth);
        } else if (view === "week") {
          let filteredAppointments = {};
          if (groupedByDate && Array.isArray(weekDates)) {
            const weekDatesSet = new Set(weekDates?.map((date) => moment(date).format("YYYY-MM-DD")));
            Object.keys(groupedByDate).forEach((date) => {
              const appointmentDate = moment(new Date(date)).format("YYYY-MM-DD");
              if (weekDatesSet.has(appointmentDate)) {
                filteredAppointments[date] = groupedByDate[date];
              }
            });
          }
          setFilteredAppointments(filteredAppointments);
        } else if (view === "day") {
          let filteredAppointments = {};
          if (groupedByDate) {
            const selectedDate = moment(selectedDayDate).format("YYYY-MM-DD");
            Object.keys(groupedByDate).forEach((date) => {
              const appointmentDate = moment(new Date(date)).format("YYYY-MM-DD");
              if (appointmentDate === selectedDate) {
                filteredAppointments[date] = groupedByDate[date];
              }
            });
            setFilteredAppointments(filteredAppointments);
          }
        }
      } else {
        setAppoinments([]);
        auth.setAppointmentsData([]);
        setUpcomingAppointments({});
        setFilteredAppointments({});
      }

    } catch (error) {
      console.error("Error fetching appointments:", error);
      setAppoinments([]);
      auth.setAppointmentsData([]);
      setUpcomingAppointments({});
      setFilteredAppointments({});
    }

  };

  useEffect(() => {
    ManageAppointmentsData();
  }, [ManageAppointmentsData]);

  useEffect(() => {
    const { startDate, endDate } = calculateDateRange(view, currentDate, weekDates, selectedDayDate);

    const unsubscribe = subscribeToAppointmentsByDates(
      startDate,
      endDate,
      companyId,
      null,
      (appointments) => {

        fetchAppointments(appointments);

        if (selectedAppointment) {
          const updatedSelectedAppointment = appointments?.find(appt => appt?.id === selectedAppointment?.id);
          setSelectedAppointment(updatedSelectedAppointment || null);
        }
      },
      (error) => console.log(error)
    );

    return () => unsubscribe && unsubscribe();
  }, [view, currentDate, weekDates, selectedDayDate, companyId]);


  useEffect(() => {
    const unsubscribe = subscribeToSettings(
      companyId,
      "appointment_settings",
      (newSettings) => {
        setSettingsData(newSettings);
      },
      (err) => console.log(err)
    );

    return () => unsubscribe && unsubscribe();
  }, [companyId]);

  const handleEmpNameChange = (e) => {
    const selectEmployee = e;
    setEmpNames(selectEmployee);

    if (selectEmployee === "Inactive Employee") {
      const inactive = employeeNameList.filter((item => inactiveEmployee.some(inac => inac.id === item.value)))
      if (inactive.length > 0) {
        setEmployeeNameList((prevList) => {
          const updatedList = [{ label: "All", value: "All" }];

          const activeEmployeeNames = employeeDetails
            .filter(emp => !inactiveEmployee.some(inactiveEmp => inactiveEmp.id === emp.id))
            .map(emp => ({
              value: emp?.id,
              client: emp?.clients,
              label: `${emp?.firstName} ${emp?.lastName}`,
              email: emp?.email,
            }))?.sort((a, b) => a?.label?.localeCompare(b?.label));

          updatedList.push(...activeEmployeeNames);

          updatedList.push({ label: "Inactive Employee", value: "Inactive Employee" });

          return updatedList;
        });
      } else {
        const employeeNames = inactiveEmployee.map(emp => ({
          value: emp?.id,
          client: emp?.clients,
          label: `${emp?.firstName} ${emp?.lastName}`,
          email: emp?.email,
        }))?.sort((a, b) => a?.label?.localeCompare(b?.label));

        setEmployeeNameList((prevList) => {
          const updatedList = [...prevList];

          employeeNames.forEach(inactiveEmp => {
            if (!prevList.some(emp => emp.value === inactiveEmp.value)) {
              updatedList.push(inactiveEmp);
            }
          });

          return updatedList;
        });
      }
    } else {
      const isInactive = inactiveEmployee.some(emp => emp.id === selectEmployee);

      if (!isInactive) {
        setEmployeeNameList((prevList) => {
          const updatedList = [{ label: "All", value: "All" }];

          const activeEmployeeNames = employeeDetails
            .filter(emp => !inactiveEmployee.some(inactiveEmp => inactiveEmp.id === emp.id))
            .map(emp => ({
              value: emp?.id,
              client: emp?.clients,
              label: `${emp?.firstName} ${emp?.lastName}`,
              email: emp?.email,
            }))?.sort((a, b) => a?.label?.localeCompare(b?.label));

          updatedList.push(...activeEmployeeNames);

          updatedList.push({ label: "Inactive Employee", value: "Inactive Employee" });

          return updatedList;
        });
      }
    }
  };

  const handelClientNameChange = (e) => {
    const selectClient = e;
    setClientName(selectClient);
  };

  const handelCancelCloseDialog = () => {
    setCancelAppt(false);
  }

  const handelSingleOrSeriesApptCancelDialog = async (ids, mode) => {
    // const ids = editAppointmentData?.id;
    const data = {
      name: `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`,
      id: auth?.userProfile?.id
    }
    setCancelAppt(false);
    const response = await DeleteAppointment(ids, data, mode);
    if (response.success) {
      setIsDeleteDialogOpen(true);
      trackEvent(CMS_EVENTS.APPOINTMENT_DELETED, {
        user_id: auth?.userProfile?.id,
        appointment_ids: ids,
        mode: mode,
      });
    } else {
      console.error("Failed to delete appointment:", response.error);
    }
  }

  const handelSuccelDeleteCloseDialog = async () => {
    CommonContext?.setLoader(true);
    auth.setEditAppointmentData({});
    auth.setUpdateAppointmentData({});
    setIsDeleteDialogOpen(false);
    setIsModalOpen(false);
    setCancelAppt(false);
    // await delay(3700);
    // await fetchAppointments();
    toast?.({
      title: "Success",
      description: "Appointment Deleted Successfully",
      variant: "default",
    });
    CommonContext?.setLoader(false);
  };


  const redirectToSchedule = () => {
    auth.setIsExpanded(false);
    navigate("/operations/appoinmentSchedule");
  };

  const handleScrollToAppointments = (date) => {
    const dateKey = date.format("MMMM D, YYYY");
    const targetRef = appointmentRefs.current[dateKey];
    if (targetRef) {
      targetRef.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleAppointmentOpen = (appointment) => {
    setIsModalOpen(true);
    setSelectedAppointment(appointment);
  };

  const allAlerts = [
    { label: 'All Alerts', value: 'allAlerts' },
    { label: 'Today Alerts', value: 'todayAlerts' },
    { label: 'No Alerts', value: 'noAlerts' }
  ];

  const handleAlertChange = (e) => {
    const selectAlert = e;
    setAlerts(selectAlert);
  }

  return (
    <>
      <Container className={auth.isExpanded ? "Expandcontainers" : "containers"}>
        {!auth.isExpanded && (
          <PageTitle
            pageTitle="View Schedule"
            showBreadcrumb={[
              { label: "Home", to: "/", onclick: () => auth.setIsExpanded(false) },
              { label: "Appoinments" },
            ]}
            BreadCrumbCurrentPageTitle={"View Schedule"}
            showLastSeen={true}
            {...(auth?.userProfile?.role !== "Client" && {
              buttonTitle: "Schedule Now",
              // icons={<Plus className="h-4 w-4 mr-5" />}
              buttonClass: "d-flex flex-center",
              buttonStyle: {
                color: "white",
                backgroundColor: "#16A34A",
                padding: "8px 16px",
                borderRadius: "5px",
              },
              buttonClick: () => redirectToSchedule(),
            })}
          />
        )}
        <div className={isMobile ? "" : "ph-25"}>
          <div className="sectionBox dark:bg-[#1A1F2C]">
            {!isMobile && (
              <div style={{ margin: "-10px 0px 0px -10px" }}>
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "relative",
                    cursor: "pointer",
                    right: "9px",
                    top: "-9px"
                  }}
                >
                  <Tooltip title={auth.isExpanded ? "Show Menu" : "Hide Menu"} arrow classes={{ tooltip: classes.customTooltip }}>
                    <svg
                      viewBox="0 0 100 100"
                      style={{
                        width: "77%",
                        height: "77%",
                        position: "absolute",
                      }}
                      onClick={() => auth.setIsExpanded(!auth.isExpanded)}
                    >
                      <polygon points="100,0 0,100 0,0" fill="currentColor" className="text-[#eaeaea] dark:text-gray-600" />
                    </svg>
                  </Tooltip>
                  <NorthWestIcon fontSize="medium"
                    className="dark:text-white bg-[#020817]"
                    style={{
                      position: "absolute",
                      left: "-2%",
                      transform: auth.isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease-in-out",
                      backgroundColor: "transparent",
                    }}
                    onClick={() => auth.setIsExpanded(!auth.isExpanded)}
                  />
                </div>
              </div>
            )}
            {isMobile ? (
              <div className="d-flex flex-direction-column mb-15">
                {/* <div className="mb-20 d-flex flex-justify-flexend">
                <Button
                  variant="contained"
                  className={`${isMobile || isLandscape ? "pv-10 ph-10" : "pv-10 ph-20"
                    }`}
                  style={{ backgroundColor: "#16A34A", color: "white" }}
                  onClick={redirectToSchedule}
                >
                  Schedule Now
                </Button>
              </div> */}
                <div className="mb-20 calendarSelectWidth2">
                  <SingleSelectNew
                    value={alerts}
                    name={"alerts"}
                    label={"Alerts"}
                    contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                    itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                    onChange={handleAlertChange}
                    options={allAlerts}
                    datetime={true}
                  />
                </div>
                <div className="mb-20 calendarSelectWidth">
                  <SingleSelectNew
                    value={empNames}
                    name={"employeeName"}
                    label={"Employee Name"}
                    onChange={handleEmpNameChange}
                    options={employeeNameList}
                    contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                    itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                    datetime={true}
                    inactive={true}
                    allEmployees={allEmployees}
                  />
                </div>
                {auth?.userProfile?.role !== "Client" && (
                  <div className="mb-20 calendarSelectWidth">
                    <SingleSelectNew
                      value={clientName}
                      name={"clientName"}
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      label={"Client Name"}
                      onChange={handelClientNameChange}
                      options={clientNameList}
                      datetime={true}
                    />
                  </div>
                )}
              </div>
            ) : null}

            <NavBar
              empNames={empNames}
              handleEmpNameChange={handleEmpNameChange}
              employeeNameList={employeeNameList}
              upcomingAppointments={upcomingAppointments}
              setView={setView}
              view={view}
              setCurrentDate={setCurrentDate}
              currentDate={currentDate}
              weekDates={weekDates}
              setWeekDates={setWeekDates}
              setSelectedDayDate={setSelectedDayDate}
              selectedDayDate={selectedDayDate}
              clientNameList={clientNameList}
              clientName={clientName}
              handelClientNameChange={handelClientNameChange}
              allEmployees={allEmployees}
              handleAlertChange={handleAlertChange}
              alerts={alerts}
              allAlerts={allAlerts}
            />

            <div style={{ display: view === "month" ? "block" : "none" }}>
              <MonthView
                employeeNameList={allEmployees}
                handleScrollToAppointments={handleScrollToAppointments}
                appointmentRefs={appointmentRefs}
                currentDate={currentDate}
                empNames={empNames}
                clientName={clientName}
                settingsData={settingsData}
                alerts={alerts}
              />
            </div>
            {!isMobile && (
              <div className="mb-20 alert-container" style={{ display: view === "month" ? "block" : "none" }}>
                <div className="toggle-containers">
                  <button onClick={() => setAlerts('allAlerts')} className={`toggle-buttons ${alerts === 'allAlerts' ? 'active' : ''}`}>
                    All Alerts
                  </button>
                  <button onClick={() => setAlerts('todayAlerts')} className={`toggle-buttons ${alerts === 'todayAlerts' ? 'active' : ''}`}>
                    Today Alerts
                  </button>
                  <button onClick={() => setAlerts('noAlerts')} className={`toggle-buttons ${alerts === 'noAlerts' ? 'active' : ''}`}>
                    No Alerts
                  </button>
                </div>
              </div>
            )}
            <div style={{ display: view === "week" ? "block" : "none" }}>
              <WeekView
                weeksAllDays={weekDates}
                clientDetails={clientDetails}
                empNames={empNames}
                clientName={clientName}
                fetchAppointments={fetchAppointments}
                employeeDetails={allEmployees}
                settingsData={settingsData}
              />
            </div>

            <div style={{ display: view === "day" ? "block" : "none" }}>
              <DayView
                allDays={selectedDayDate}
                clientDetails={clientDetails}
                empNames={empNames}
                clientName={clientName}
                employeeDetails={allEmployees}
                fetchAppointments={fetchAppointments}
                settingsData={settingsData}
              />
            </div>

            <div>
              <AppointmentsDetailComponent
                appointments={filteredAppointment}
                handleAppointmentOpen={handleAppointmentOpen}
                appointmentRefs={appointmentRefs}
                empNames={empNames}
                clientName={clientName}
                settingsData={settingsData}
                alerts={alerts}
              />
            </div>
            {selectedAppointment && (
              <ScheduleModal
                isModalOpen={isModalOpen}
                selectedAppointment={selectedAppointment}
                isMobile={isMobile}
                isLandscape={isLandscape}
                clientDetails={clientDetails}
                employeeDetails={allEmployees}
                appoinments={appoinments}
                auth={auth}
                setIsModalOpen={setIsModalOpen}
                setCancelAppt={setCancelAppt}
                settingsData={settingsData}
                alerts={alerts}
              />
            )}
          </div>
        </div>
      </Container>

      {cancelAppt && (
        <DeleteApptDialog open={cancelAppt} client={clientDetails} onConfirm={handelSingleOrSeriesApptCancelDialog}
          auth={editAppointmentData} onClose={handelCancelCloseDialog} appointments={updateAppointmentData} />
      )}
      {isDeleteDialogOpen && (
        <CommonSuccessDialog
          open={isDeleteDialogOpen}
          onClose={handelSuccelDeleteCloseDialog}
          title="Appointment Deleted Successfully"
          message="Your appointment has been successfully deleted. Thank you for using our scheduling system."
        />
      )}
    </>
  );
};

const ScheduleModal = (props) => {
  const { isModalOpen } = props;
  const [isModalO, setIsModalO] = useState(false);


  useEffect(() => {
    if (isModalOpen) {
      setIsModalO(isModalOpen);
    } else {
      setTimeout(() => {
        setIsModalO(isModalOpen);
      }, 250);
    }

  }, [isModalOpen]);

  const handleOverlayClick = (e) => {
    if (e.target?.classList?.contains('modal-overlay')) {
      props?.setIsModalOpen(false);
      props?.auth.setEditAppointmentData({});
      props?.auth.setUpdateAppointmentData({});
    }
  };

  return isModalO ? (
    <div className={`modal-overlay active`} onClick={handleOverlayClick} >
      <div className={`modal-content dark:bg-[#1A1F2C] ${isModalOpen ? 'slideUpModal' : 'slideDownModal'}`}>
        {" "}
        <AppointmentModal {...props} />{" "}
      </div>
    </div>
  ) : null;
};
export default ManageAppointments;
